import { Box, Button } from "@mui/material";
import { useMediaQuery, useTheme } from '@mui/material';

import LoginIcon from '@mui/icons-material/RocketLaunchTwoTone';
import LoginOptionsDialog from './LoginOptionsDialog';
import React from 'react';

const LoginButton = ({ ...props }) => {
    const theme = useTheme();
    const fullscreen = useMediaQuery(theme.breakpoints.down('lg'));
    const [showLoginOptions, setShowLoginOptions] = React.useState(false);

    return (
        <Box>
            <LoginOptionsDialog
                open={showLoginOptions}
                onClose={() => setShowLoginOptions(false)}
                layout={fullscreen ? 'fullscreen' : 'center'}
            ></LoginOptionsDialog>
            <Button
                variant="outlined"
                color="primary"
                size="large"
                startIcon={<LoginIcon />}
                {...props}
                sx={{
                    borderRadius: 10,
                    borderWidth: 2
                }}
                onClick={() => {
                    setShowLoginOptions(true);
                }}>
                Click here to ask yours
            </Button>
        </Box>
    );
};

export default LoginButton;
